import React, { Fragment, useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";

import ai from "../../helpers/axios";
import Loader from "../loader";
import PageHeaderRowSearch from "../shared/page-header-row-search";

const PaymentsLinkingContent = () => {
  const location = useLocation();
  const history = useHistory();
  const { user, getAccessTokenSilently, loginWithRedirect } =
    useAuth0();

  const userRoles = user && user["https://new.evojets.com/roles"];

  const superAdmin = userRoles.some((role) => "Super Admin" === role);

  useEffect(() => {
    if (!superAdmin) {
      toast.error("You do not have permission to view this page.");
      history.push("/");
    }
  }, [superAdmin, history]);

  useEffect(() => {
    document.title = "Xero Payments Linking | evoJets HQ";
  }, []);

  const handleXeroUrl = useCallback(async () => {
    const token = await getAccessTokenSilently().catch(() => {
      return loginWithRedirect();
    });

    try {
      await ai.auth(token).get(`/api/xero/callback${location.search}`);

      history.replace("/payments-linking");
    } catch (error) {}
  }, [getAccessTokenSilently, loginWithRedirect, history, location]);

  useEffect(() => {
    handleXeroUrl();
  }, [handleXeroUrl]);

  return (
    <Fragment>
      <PageHeaderRowSearch
        h1={
          <div className="d-flex align-items-center mb-1">
            <h5 className="mb-0">Xero Accounts</h5>
          </div>
        }
        extraClasses="page-header-trips-l1"
      />

      <Loader additionalClasses="position-absolute top-50 start-50 translate-middle" />
    </Fragment>
  );
};

export default PaymentsLinkingContent;
